import React, { Component, Fragment } from 'react';
import { ScatterPlot } from './PlotComponent';
import { RenderVirtualTable } from './TableComponent'
import { CustomLoading, Loading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Control, Form } from 'react-redux-form';
import { FormGroup, Label, Input, Button, 
         Breadcrumb, BreadcrumbItem, Alert } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { ExcelLink } from "./ExportComponent";
import { CustomListSelect, CustomSelect, sort_by, pick, filtered_data, previous_date } from './Functions';
import { vol, value_at_risk, sharpe, median_ret, avg_ret, median_of_means } from './analytics';
import { risk_metric_labels, ret_metric_labels } from '../shared/data';
import { postRequest } from '../redux/ActionCreators';

import moment from 'moment';
import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    asset_series: state.asset_series,
    asset_tks_list: state.asset_tks_list,
    asset_series_range: state.asset_series_range,
    optim_params: state.optim_params
  };
};


class Assets extends Component {
  constructor(props){
      super(props);
      this.state = {
        show_indices:true,
        show_products:false,
        msg:null,
        loading_asset_names:false,
        search_text:null,
        sort_by:null
      };
      this.loadSeries = this.loadSeries.bind(this);
      this.updatePortfolio = this.updatePortfolio.bind(this);
      this.renderHeader = this.renderHeader.bind(this);
  }
  
  loadSeries(){
    if (this.props.asset_tks_list.length>1){
      Auth.currentSession().then(res=> {
        this.props.fetchSeries({
          tks:this.props.asset_tks_list.map(x=>x.value), 
          ref_curr:this.props.optim_params.ref_curr,
          to_returns:true,
          rets_period:this.props.optim_params.rets_per,
        }, res.getIdToken().getJwtToken(), 10, 3);
      });
      this.props.resetModel('cons');
    }else{
      this.setState({msg:"Seleccionar 2 o más activos."});
    }
  }

  async updatePortfolio(e){
    this.props.changeModel("optim_params.ref_port_assets", e==null ? null : e.value);
    if (e?.value){
      this.setState({loading_asset_names:true});
      try {
        const port_saa = await postRequest({
          port_id:e.value, 
          last_update:true,
          res_url:false
        }, 'port_saa');
        if (port_saa.data && port_saa.data.length>0){
          this.props.changeModel('asset_tks_list', this.props.user_wm.data.assets.filter(d => (new Set(port_saa.data.map(k=>k.Asset))).has(d.Asset)).map(x=>{
              return {value:x.Ticker, label:x.Isin=="" ? `${x.Asset} | ${x.Ticker}` : `${x.Asset} | ${x.Isin}`};
            })
          );
        }
        this.setState({loading_asset_names:false});
      } catch(error) {
        console.log(error.message);
        this.setState({loading_asset_names:false});
      }
    }
  }

  renderHeader(){
    const tk_options = this.props.user_wm.data.assets
                        .filter(x=>(this.state.show_indices && x.AssetType=="Index") || (this.state.show_products && x.AssetType=="Fund/ETF"))
                        .map(x=>{return({value:x.Ticker, label:x.Isin=="" ? `${x.Asset} | ${x.Ticker}` : `${x.Asset} | ${x.Isin}`})}).sort(sort_by("label"));

    return(
      <Fragment>
        <div className="row justify-content-center" id="series">
          <div className="col-12 m-3">
            <center><h5>Series Retorno Total</h5></center>
            <a className='linkcol' href='#summ'>resumen &darr;</a>
          </div>
        </div>
        <div className='row m-2 justify-content-center align-items-end'>
          <div className='col-2'>
            <Label check>
              <Input type="checkbox"
                checked={this.state.show_indices}
                onChange={()=>this.setState({show_indices:!this.state.show_indices})}
                />{' '}
                Índices
            </Label>
          </div>
          <div className='col-2'>
            <Label check>
              <Input type="checkbox"
                checked={this.state.show_products}
                onChange={()=>this.setState({show_products:!this.state.show_products})}
                />{' '}
                Fondos/ETF
            </Label>
          </div>
        </div>
        <div className='row m-4 justify-content-center align-items-end'>
          {this.state.loading_asset_names ?
            <div className='col-4'>
              <CustomLoading msg="actualizando activos" icon="fa-compass"/>
            </div>
          :
            <div className={`col-${this.props.asset_tks_list.length>4 ? 6 :4}`}>
              <Label>Seleccionar Activos</Label>
              <CustomSelect
                name="assets"
                value={this.props.asset_tks_list}
                options={tk_options}
                onChange={(e)=>{this.props.changeModel('asset_tks_list', e.map(x=>{
                  return {value:x.value, label:x.label};
                }))}}
                itemSize={50}
                className="basic-multi-select"
                placeholder="seleccionar..."
              />
            </div>
            
          }
          <div className='col-2'>
            <Label>Seleccionar Portafolio</Label>
            <CustomListSelect
              options={this.props.user_wm.data.ports_list}
              isClearable={true}
              value={this.props.optim_params.ref_port_assets==null ? null : {value:this.props.optim_params.ref_port_assets, label:this.props.optim_params.ref_port_assets}}
              onChange={(e)=>this.updatePortfolio(e)}
              itemSize={50}
              className="basic-single"
              placeholder="seleccionar portafolio"
            />
          </div>
          <div className='col-2'>
            <Button className="btn-corp"
              onClick={this.loadSeries}
            >
              Seleccionar Activos
            </Button>
          </div>
        </div>
        <Form model="optim_params" onSubmit={(values) => this.handleSubmit(values)}>
          <div className='row justify-content-center align-items-end m-3'>
              <div className='col-1'>
                  <label htmlFor=".ref_curr"><small>Moneda</small></label>
                  <Control.select 
                      model=".ref_curr" 
                      type="select" 
                      name="ref_curr"
                      className="form-control"
                      onChange={this.loadSeries}
                      >
                      <option>USD</option>
                      <option>CLP</option>
                      <option>CLF</option>
                      <option>MXN</option>
                      <option>COP</option>
                      <option>PEN</option>
                      <option>UYU</option>
                  </Control.select>
              </div>
              <div className='col-2'>
                  <label htmlFor=".risk_metric"><small>Métrica de Riesgo</small></label>
                  <Control.select 
                      model=".risk_metric" 
                      type="select" 
                      name="risk_metric"
                      className="form-control"
                      >
                      <option value="vol">Volatilidad</option>
                      <option value="var">VeR 95%</option>
                  </Control.select>
              </div>
              <div className='col-2'>
                  <label htmlFor=".ret_metric"><small>Métrica de Retorno</small></label>
                  <Control.select model=".ret_metric" type="select" name="ret_metric"
                      className="form-control">
                      <option value="mean">Promedio Anual.</option>
                      <option value="median">Mediana Anual.</option>
                      <option value="mom">Retorno MoM (12M)</option>
                  </Control.select>
              </div>
              <div className='col-2'>
                  <label htmlFor=".rets_per"><small>Periodo Retornos</small></label>
                  <Control.select 
                      model=".rets_per" 
                      type="select" 
                      name="rets_per"
                      className="form-control"
                      onChange={this.loadSeries}
                      >
                      <option value="daily">Diario</option>
                      <option value="monthly">Mensual</option>
                      <option value="quarterly">Trimestral</option>
                  </Control.select>
              </div>
              <div className='col-1'>
                <label><small>Rango</small></label>
                <Input 
                  type="select" value={this.props.asset_series_range} 
                  onChange={(e)=>this.props.changeModel('asset_series_range',e.target.value)}
                >
                  {['1Y',"500D", '3Y','5Y','10Y'].map((x,i)=>{
                    return (<option key={i}>{x}</option>);
                  })}
                </Input>
              </div>
          </div>
        </Form>
        <div className="row mt-4 justify-content-center">
            <div className="col-4">
              <Alert
                color='secondary'
                isOpen={this.state.msg!==null}
                toggle={()=>this.setState({msg:null})}
                fade={false}>
                  {this.state.msg}
              </Alert>
            </div>
        </div>
        
      </Fragment>
      );    
  }
  render() {
      if(this.props.user_wm.isLogging ){
        return(
          <div className='container'>
            <div className="row m-5 justify-content-center">
                <Loading />
            </div>
          </div>
        );
      } else if(this.props.asset_series.isLoading){
        return(
          <div className='container'>
            <div className="row m-5 justify-content-center">
                <CustomLoading msg="consultando series" icon="fa-database"/>
            </div>
          </div>
        );
      } else if(this.props.asset_series.errMess){
          return(
              <div className="container">
                {this.renderHeader()}
                <div className="row justify-content-center m-5">
                  <h4>{this.props.asset_series.errMess}</h4>
                </div>
              </div>
          );
      } else {
        //const prev_date = moment().subtract(parseFloat(this.props.asset_series_range.replace('Y',''))*12, 'months');
        const prev_date = previous_date(this.props.asset_series_range, null, false);
        const asset_series = this.props.asset_series.data==null || this.props.asset_series.data.ts.length==0 ? null : 
                             this.props.asset_series.data.ts.filter(item=>Date.parse(item.Date)>prev_date);
        const freq_map = {"daily":252, "monthly":12, "quarterly":4};
        let assets_summ = asset_series!=null && asset_series.length>0 ? 
                          Object.keys(asset_series[0]).filter(x=>x!="Date").map(item=>{
                            let rets_temp = asset_series.map(x=>x[item]);
                            if (this.props.asset_series.data.summ.map(x=>x['Ticker']).includes(item)){
                              return {
                                Id:this.props.user_wm.data.assets.find(k=>k.Ticker==item).Asset, 
                                ...this.props.asset_series.data.summ.filter(k=>k['Ticker']==item)[0], 
                                [ret_metric_labels[this.props.optim_params.ret_metric]]:100*(
                                  this.props.optim_params.ret_metric=="mean" ? avg_ret(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.ret_metric=="median" ? median_ret(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.ret_metric=="mom" ? median_of_means(rets_temp, 12, null, freq_map[this.props.optim_params.rets_per]) :
                                  0
                                  ), 
                                "Retorno Esperado":100*(
                                  this.props.optim_params.ret_metric=="mean" ? avg_ret(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.ret_metric=="median" ? median_ret(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.ret_metric=="mom" ? median_of_means(rets_temp, 12, null, freq_map[this.props.optim_params.rets_per]) :
                                  0
                                  ),
                                [risk_metric_labels[this.props.optim_params.risk_metric]]:100*(
                                  this.props.optim_params.risk_metric=="vol" ? vol(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.risk_metric=="var" ? value_at_risk(rets_temp, 0.95) :
                                  0  
                                  ), 
                                "Sharpe":sharpe(rets_temp, 1),
                                'Fecha Inicial':asset_series[0].Date,
                                'Fecha Final':asset_series.slice(-1)[0].Date
                              };
                            }else{
                              const keys_temp = Object.keys(this.props.asset_series.data.summ[0]).reduce((acc, curr) => {
                                                    acc[curr] = '';
                                                    return acc;
                                                }, {});
                              return {
                                Id:this.props.user_wm.data.assets.find(k=>k.Ticker==item).Asset, 
                                ...keys_temp, 
                                'Ticker':item, 
                                [ret_metric_labels[this.props.optim_params.ret_metric]]:100*(
                                  this.props.optim_params.ret_metric=="mean" ? avg_ret(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.ret_metric=="median" ? median_ret(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.ret_metric=="mom" ? median_of_means(rets_temp, 12, null, freq_map[this.props.optim_params.rets_per]) :
                                  0
                                  ), 
                                "Retorno Esperado":100*(
                                  this.props.optim_params.ret_metric=="mean" ? avg_ret(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.ret_metric=="median" ? median_ret(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.ret_metric=="mom" ? median_of_means(rets_temp, 12, null, freq_map[this.props.optim_params.rets_per]) :
                                  0
                                  ),
                                [risk_metric_labels[this.props.optim_params.risk_metric]]:100*(
                                  this.props.optim_params.risk_metric=="vol" ? vol(rets_temp, freq_map[this.props.optim_params.rets_per]) :
                                  this.props.optim_params.risk_metric=="value_at_risk" ? value_at_risk(rets_temp, 0.95) :
                                  0  
                                  ),
                                "Sharpe":sharpe(rets_temp, 1),
                                'Fecha Inicial':asset_series[0].Date,
                                'Fecha Final':asset_series.slice(-1)[0].Date
                              };
                            }
                        })
                        :null;
        this.props.changeModel('assets_summ', assets_summ);
        
        const assets_summ_filt = assets_summ!==null ? 
          filtered_data(assets_summ.map(item=>pick(item, ["Id", "Ticker", "Clase", "Moneda", "Retorno Esperado", risk_metric_labels[this.props.optim_params.risk_metric], "Sharpe", "Fecha Inicial", "Fecha Final"])), this.state.search_text) : null;

        return (
          <div className="container">
            <div className="row mt-5 justify-content-center">
              <div className="col-auto">
                  <h4>Optimización</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className="col-auto">
                <Breadcrumb>
                  <BreadcrumbItem active>Universo Invertible</BreadcrumbItem>
                  <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                  <BreadcrumbItem><Link to='/builder/optim/results'>Resultados</Link></BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>
            {this.renderHeader()}
            {assets_summ!==null ?
            <Fragment>
              <div className="row mt-5 mb-3 justify-content-center" id="summ">
                <div className="col-12">
                  <center><h5>Resumen</h5></center>
                  <a className='linkcol' href='#series'>series &uarr;</a>
                </div>
              </div>
              <div className="row m-4 justify-content-center">
                <div className='col-2'>
                    <Input
                      size="sm"
                      type="textarea" 
                      name="search_text" 
                      id="search_text" 
                      rows="1"
                      placeholder="Buscar..."
                      onChange={(e)=>{this.setState({search_text:e.target.value})}}
                    />
                </div>
                <div className='col-2'>
                    <CustomListSelect
                      options={["Retorno Esperado", "Volatilidad Anual.", "Sharpe"].map(x=>{
                        return {value:x, label:x};
                      })}
                      isClearable={true}
                      value={this.state.sort_by ? {value:this.state.sort_by, label:this.state.sort_by} : null}
                      onChange={(e)=>this.setState({sort_by:e?.value})}
                      itemSize={50}
                      className="basic-single"
                      placeholder="ordenar por..."
                      fontSize={10}
                      itemSize={30}
                    />
                </div>
              </div>
              { assets_summ_filt.length>0 ?
              <>
                <div className="row mt-3 justify-content-center">
                  <div className="col-auto">
                    <RenderVirtualTable 
                      data={this.state.sort_by ? 
                              assets_summ_filt.sort(sort_by(this.state.sort_by, false))
                            :
                              assets_summ_filt
                            } 
                      to_perc={[false, false, false, true, true, true]} 
                      to_fixed={[false, false, false, false, false, false, true]} 
                      cell_width={["200px", "150px", '100px', '70px', '70px', '70px', '70px', '100px', '100px']}
                      item_size={45}
                      style="black"
                      fontsize={12}                    
                      />
                  </div>
                </div>
                <div className="row mt-2 justify-content-center">
                  <div className="col-auto">
                    <ExcelLink class_name='link-btn' label='descargar resumen' data={assets_summ} filename="resumen.xlsx" />
                  </div>
                </div>
                <div className="row mt-5 justify-content-center">
                  <div className='col-auto'>
                    <ScatterPlot
                      data={assets_summ_filt}
                      color="#000000"
                      xlabel={risk_metric_labels[this.props.optim_params.risk_metric]}
                      ylabel={ret_metric_labels[this.props.optim_params.ret_metric]}
                      xAxisId={risk_metric_labels[this.props.optim_params.risk_metric]}
                      yAxisId={"Retorno Esperado"}
                      dataName='Id'
                      zAxisId='Id'
                      dataName='Id'
                      width={580}
                      ml={100}
                      mr={100}
                      showLabels={true}
                      percTooltip={true}
                      xpercAxis={true}
                      ypercAxis={true}
                      legend={false}
                    />
                  </div>
                </div>
              </>
            : 
              <div className="row m-5 justify-content-center">
                <div className="col-auto">
                  <h6>No hay datos que coincidan con la búsqueda.</h6>
                </div>
              </div>
            }
            </Fragment>
            :<Fragment></Fragment>
            }
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(Assets));